import React from 'react';
import { connect } from 'react-redux';
import Style from './DataControlEntity.module.css';

// Entities & Attributes registry — the metadata the engine queries. After the
// Entity layer was collapsed into the Service Entity, each service entity IS the
// entity: one card per entity with the inspectable attributes it owns. Read-only,
// seeded by DB scripts.
const EntitiesAttributes = (props) => {
  const { serviceEntities } = props;
  const entities = (serviceEntities || []).slice().sort((a, b) => (a.iOrder || 0) - (b.iOrder || 0));

  return (
    <div>
      <div style={{ marginBottom: '8px' }}>
        <h1 className={Style.pageTitle}>Entities &amp; Attributes</h1>
        <p className={Style.pageSubtitle}>
          The metadata registry the engine queries. Each entity maps to a physical table/view; attributes are
          the inspectable fields. Read-only system reference.
        </p>
      </div>

      {entities.length === 0 && (
        <div className={Style.card}>
          <div className={Style.cardBody}>
            <div style={{ textAlign: 'center', padding: '24px', color: '#6b7280' }}>No entities</div>
          </div>
        </div>
      )}

      {entities.map((ent) => {
        const meta = [
          ent.code,
          ent.tableName ? `table ${ent.tableName}` : null,
          ent.viewName ? `view ${ent.viewName}` : null,
          `iOrder ${ent.iOrder}`,
          ent.isActive ? 'active' : 'inactive',
        ].filter(Boolean).join(' · ');
        const attrs = (ent.attributes || []).slice().sort((a, b) => (a.iOrder || 0) - (b.iOrder || 0));

        return (
          <div className={Style.card} key={ent.serviceEntityId}>
            <div className={Style.cardHeader}>
              <div>
                <div className={Style.cardTitle}>
                  {ent.name}{' '}
                  <span className={`${Style.badge} ${ent.kind === 'event' ? Style.blue : Style.neutral}`}>{ent.kind}</span>
                </div>
                <div className={`${Style.cardSubtitle} ${Style.mono}`}>{meta}</div>
              </div>
            </div>
            <div className={Style.cardBody}>
              <table className={Style.table}>
                <thead><tr><th>Attribute</th><th>Code</th><th>Data Type</th></tr></thead>
                <tbody>
                  {attrs.map((a) => (
                    <tr key={a.attributeId}>
                      <td style={{ fontWeight: 500 }}>{a.name}</td>
                      <td className={Style.mono}>{a.code}</td>
                      <td><span className={`${Style.badge} ${Style.neutral}`}>{a.dataType}</span></td>
                    </tr>
                  ))}
                  {attrs.length === 0 && (
                    <tr><td colSpan={3} style={{ color: '#6b7280' }}>No attributes defined.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const mapStateToProps = (state) => ({
  serviceEntities: state.entities.dataControlEntity.serviceEntities,
});

export default connect(mapStateToProps)(EntitiesAttributes);
